import React from 'react'
import OlcuTablosu from '../../components/table/OlcuTablosu'

const kareTelOlcu = [
  {
    gAralik: '1.5x1.5cm (15x15mm)',
    yukseklik: '1000mm',
    genislik: '2000mm',
    kalinlik: '2mm , 3mm',
  },
  {
    gAralik: '2x2cm (20x20mm)',
    yukseklik: '1000mm',
    genislik: '2000mm',
    kalinlik: '2mm , 3mm',
  },
  {
    gAralik: '2.5x2.5cm (25x25mm)',
    yukseklik: '1000mm',
    genislik: '2000mm',
    kalinlik: '2mm, 3mm, 4mm',
  },
  {
    gAralik: '2.5x2.5cm (25x25mm)',
    yukseklik: '1000mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm',
  },
  {
    gAralik: '3x3cm (30x30mm)',
    yukseklik: '1500mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm',
  },
  {
    gAralik: '4x4cm (40x40mm)',
    yukseklik: '1000mm',
    genislik: '2000mm',
    kalinlik: '2mm, 3mm, 4mm, 5mm',
  },
  {
    gAralik: '4x4cm (40x40mm)',
    yukseklik: '1000mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm',
  },
  {
    gAralik: '4x4cm (40x40mm)',
    yukseklik: '2000mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm',
  },
  {
    gAralik: '5x5cm (50x50mm)',
    yukseklik: '1000mm',
    genislik: '2000mm',
    kalinlik: '2mm, 3mm, 4mm, 5mm',
  },
  {
    gAralik: '5x5cm (50x50mm)',
    yukseklik: '1000mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm, 6mm',
  },
  {
    gAralik: '5x5cm (50x50mm)',
    yukseklik: '2000mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm, 6mm',
  },
  {
    gAralik: '6x6cm (60x60mm)',
    yukseklik: '1000mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm, 6mm',
  },
  {
    gAralik: '9x9cm (90x90mm)',
    yukseklik: '1500mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm, 6mm',
  },
  {
    gAralik: '15x15cm (150x150mm)',
    yukseklik: '1500mm',
    genislik: '3000mm',
    kalinlik: '3mm, 4mm, 5mm, 6mm, 7mm',
  },
]
const KareGozluTablo = () => {
  return <OlcuTablosu rows={kareTelOlcu} title='Kare Gözlü Çelik Hasır Ölçü Örnekleri' />
}
export default KareGozluTablo
